import React from "react";

const ResultPrice = ({result}) => {
    const formatPrice = (price) => {

        return new Intl.NumberFormat('fr-FR', {
            style: 'currency',
            currency: 'EUR',
        }).format(price);
    }

    return(
        <div className="product-card__price">
            <span>
                {result._sale_price ? (
                    <>
                        <span
                            className="product-card__old-price">{formatPrice(result._regular_price)}</span> {formatPrice(result._sale_price)}
                    </>
                ) : formatPrice(result._regular_price)}
            </span>/unité
        </div>
    )
}

export default ResultPrice;